
export enum LogLocation {
    None,
    File,
    Console,
    Api,
    ElasticCluster
}